"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BosonSnapshotGate__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      },
      {
        internalType: "address",
        name: "_protocol",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "owner",
            type: "address"
          }
        ],
        indexed: false,
        internalType: "struct BosonSnapshotGate.Holder[]",
        name: "holders",
        type: "tuple[]"
      }
    ],
    name: "SnapshotAppended",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "SnapshotFrozen",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "SnapshotTokenCommitted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "owner",
            type: "address"
          }
        ],
        internalType: "struct BosonSnapshotGate.Holder[]",
        name: "_holders",
        type: "tuple[]"
      }
    ],
    name: "appendToSnapshot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_holder",
        type: "address"
      }
    ],
    name: "checkSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "owned",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "used",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_buyer",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_offerId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      }
    ],
    name: "commitToGatedOffer",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "freezeSnapshot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const _bytecode =
  "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";
const isSuperArgs = (xs) => xs.length > 1;
class BosonSnapshotGate__factory extends ethers_1.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  deploy(_name, _symbol, _protocol, overrides) {
    return super.deploy(_name, _symbol, _protocol, overrides || {});
  }
  getDeployTransaction(_name, _symbol, _protocol, overrides) {
    return super.getDeployTransaction(
      _name,
      _symbol,
      _protocol,
      overrides || {}
    );
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new ethers_1.utils.Interface(_abi);
  }
  static connect(address, signerOrProvider) {
    return new ethers_1.Contract(address, _abi, signerOrProvider);
  }
}
exports.BosonSnapshotGate__factory = BosonSnapshotGate__factory;
BosonSnapshotGate__factory.bytecode = _bytecode;
BosonSnapshotGate__factory.abi = _abi;
